<template>
  <div class="bg-secondary-1 rounded">
    <board :details="boardDetails" header-class="pt-2 px-1" />
    <div class="row ml-4 pl-3 py-3">
      <div class="col-12 col-lg-3">
        <span class="color-gray-6 d-block font-14">
          Servicio / Disciplina:
        </span>
        <span class="font-16 color-black">
          {{ serviceDisciplineName }}
        </span>
      </div>
      <div class="col-12 col-lg-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">
          Número de Contrato:
        </span>
        <span class="font-16 color-black">
          {{ planGeneralInfo.contractNumber | empty }}
        </span>
      </div>
      <div class="col-12 col-lg-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">
          Estatus:
        </span>
        <div style="display: flex;">
          <div
            :class="`bg-${contractStatusColor}`"
            style="height: 15px !important;
                width: 15px !important;
                border-radius: 26px;
                margin-top: 5px;"
          />
          <span class="font-16 color-black" style="padding-left: 5px;">
            {{ contractStatusName | empty }}
          </span>
        </div>
      </div>
      <div v-if="isElectronicSignature" class="col-12 col-lg-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">
          Estatus de Firma:
        </span>
        <div style="display: flex;">
          <div
            :class="`bg-${signatureStatusColor}`"
            style="height: 15px !important;
                width: 15px !important;
                border-radius: 26px;
                margin-top: 5px;"
          />
          <span class="font-16 color-black" style="padding-left: 5px;">
            {{ signatureStatusName | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//lib components
import Board from 'Board';

//constants
import rpContractStatus, {
  rpContractStatusColor,
} from '@/utils/constants/rpContractStatus.js';
import SignatureDocumentStatus, {
  SignatureDocumentStatusColor,
} from '@/utils/constants/signatureDocumentStatus.js';

export default {
  name: 'GeneralPlanInfo',
  components: {
    Board,
  },
  props: {
    planGeneralInfo: {
      type: Object,
      default: () => {},
    },
    lastAchievement: {
      type: Object,
      default: () => {},
    },
    isAchievementSummary: {
      type: Boolean,
      default: () => false,
    },
    isElectronicSignature: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    serviceDisciplineName() {
      return this.planGeneralInfo.requestServiceDisciplineTypeName
        ? `${this.planGeneralInfo.requestServiceTypeName} - ${this.planGeneralInfo.requestServiceDisciplineTypeName}`
        : this.planGeneralInfo.requestServiceTypeName;
    },
    boardDetails() {
      return [
        [
          {
            label: 'Año Escolar del Contrato:',
            data: this.planGeneralInfo?.academicYear,
            icon: 'fas fa-calendar-alt',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Nombre del Estudiante:',
            data: this.planGeneralInfo?.studentFullName,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Número de Solicitud:',
            data: this.planGeneralInfo?.requestNumber,
            icon: 'fas fa-file-invoice',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Impedimento:',
            data: this.planGeneralInfo?.studentImpediment,
            icon: 'fas fa-clipboard-list',
            cols: 'col-12 col-lg-3 w-50',
          },
        ],
      ];
    },
    contractStatusColor() {
      const statusId = this.planGeneralInfo?.contractStatusId;

      if (!statusId)
        return rpContractStatusColor[rpContractStatus.NotAvailable];

      return rpContractStatusColor[statusId];
    },
    contractStatusName() {
      return this.planGeneralInfo?.contractStatusName || '-';
    },
    signatureStatusName() {
      return !this.isAchievementSummary
        ? this.planGeneralInfo?.digitalSignatureDocumentStatus
        : this.lastAchievement?.digitalSignatureDocumentStatus;
    },
    signatureStatusColor() {
      const statusId = !this.isAchievementSummary
        ? this.planGeneralInfo?.digitalSignatureDocumentStatusId
        : this.lastAchievement?.digitalSignatureDocumentStatusId;
      const hashMap = {
        [SignatureDocumentStatus.DocNotGenerated]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.DocNotGenerated],

        [SignatureDocumentStatus.InRow]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.InRow],

        [SignatureDocumentStatus.InSigningProcess]:
          SignatureDocumentStatusColor[
            SignatureDocumentStatus.InSigningProcess
          ],

        [SignatureDocumentStatus.Canceled]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.Canceled],

        [SignatureDocumentStatus.Signed]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.Signed],
      };
      return hashMap[statusId];
    },
  },
};
</script>
